import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import AdminSidebar from "../admin/components/AdminSidebar";
import AdminHeader  from "../admin/components/AdminHeader";

export default function AdminLayout() {
  const { user, isAdmin, loading } = useAuth();
  const [collapsed, setCollapsed]  = useState(false);

  if (loading)   return <div className="d-flex justify-content-center mt-5"><span className="spinner-border" style={{ color: "#6c63ff" }} /></div>;
  if (!user)     return <Navigate to="/login"          replace />;
  if (!isAdmin)  return <Navigate to="/not-authorized" replace />;

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f8f9ff" }}>

      {/* ── Sidebar ── */}
      <AdminSidebar collapsed={collapsed} />

      {/* ── Contenu ── */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column",
                    marginLeft: collapsed ? 70 : 240, transition: "margin .3s" }}>
        <AdminHeader onToggle={() => setCollapsed(c => !c)} />
        <main style={{ flex: 1, padding: "2rem", overflowY: "auto" }}>
          <Outlet />                    {/* ← pages admin s'affichent ici */}
        </main>
      </div>

    </div>
  );
}